import { Injectable } from '@angular/core';
import { UserApplication } from '../models/application/user-application.model';

@Injectable({
  providedIn: 'root'
})
export class AppMenuService {
  private appMenu: UserApplication[] = null;

  getAppMenu(): UserApplication[] {
    return this.appMenu;
  }

  loadAppMenu(): Promise<UserApplication[]> {
    /*
      Right now the application menu is being full from the json file.
      We can change this by fetching the application menu from the control tower js file
     */
    return fetch('/assets/navmenu.json', {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Cache: 'no-cache'
      },
      /** need this to be included so that the cookies will send to the server
       * or else we will always get 302 and redirected to adfs for authentication */
      credentials: 'include'
    })
      .then(res => res.json())
      .then(menu => {
        this.appMenu = menu;
        return menu;
      })
      .catch(err => {
        console.log(err);
      });
  }
}
